import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-password-dialog',
  templateUrl: './password-dialog.component.html',
  styleUrls: ['./password-dialog.component.sass'],
})
export class PasswordDialogComponent {
  password: string = ''; 
  
  constructor(public dialogRef: MatDialogRef<PasswordDialogComponent>) {}

  // Método para fechar o diálogo e passar a senha
  confirm(): void {
    this.dialogRef.close(this.password); // Retorna a senha ao chamador
  }

  // Método para cancelar e fechar o diálogo
  cancel(): void {
    this.dialogRef.close(null); // Retorna null para indicar cancelamento
  }
}
